import { UserCardSkeleton } from '../../../../components/Skeleton';

export interface FollowersTabSkeletonProps {
  count?: number;
  className?: string;
}

export function FollowersTabSkeleton({ count = 5, className }: FollowersTabSkeletonProps) {
  return <UserCardSkeleton count={count} className={className} />;
}

export default FollowersTabSkeleton;
